<template>
  <svg
    width="100%"
    height="100%"
    :style="{ display: 'block', opacity }"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
  >
    <defs>
      <pattern
        :id="patternId"
        :width="size"
        :height="size"
        patternUnits="userSpaceOnUse"
      >
        <g fill="none" :stroke="stroke" :stroke-width="strokeWidth">
          <path :d="path1" />
          <path :d="path2" />
          <path :d="path3" />
          <path :d="path4" />
          <path :d="path5" />
        </g>
      </pattern>
    </defs>
    <rect width="100%" height="100%" :fill="`url(#${patternId})`" />
  </svg>
</template>

<script>
let counter = 0;

export default {
  name: "AliceVP1Pattern",
  props: {
    size: { type: Number, default: 96 },
    opacity: { type: Number, default: 1 },
    stroke: { type: String, default: "var(--vp-black)" },
    strokeWidth: { type: Number, default: 1.4 },
  },
  data() {
    counter += 1;
    return { patternId: `vp1-${counter}` };
  },
  computed: {
    path1() {
      const s = this.size;
      return `M0 ${s * 0.5} L${s * 0.5} 0 L${s} ${s * 0.5} L${s * 0.5} ${s}Z`;
    },
    path2() {
      const s = this.size;
      return `M${-s * 0.5} 0 L${s * 0.5} ${s}`;
    },
    path3() {
      const s = this.size;
      return `M${s * 0.5} 0 L${s * 1.5} ${s}`;
    },
    path4() {
      const s = this.size;
      return `M0 ${s * 0.5} L${s} ${-s * 0.5}`;
    },
    path5() {
      const s = this.size;
      return `M0 ${s * 1.5} L${s} ${s * 0.5}`;
    },
  },
};
</script>
